import React from 'react';
import { styled } from '@mui/material/styles';
import MuiTab, { TabProps } from '@mui/material/Tab';

const StyledTab = styled(MuiTab)<TabProps>(({ theme }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.content.white : theme.palette.content.default,
  display: 'flex',
  alignItems: 'center',
  textTransform: 'none',
  padding: '12px 21px',
  marginRight: '6px',
  maxWidth: '100%',
  font: 'normal normal 600 20px/19px Open Sans;',
  border: `1px solid ${theme.palette.content.default}`,
  // borderRadius: '6px',
  '&:hover': {
    backgroundColor: theme.palette.solidBlue.lightHover,
    color: theme.palette.solidBlue.main,
    borderColor: theme.palette.solidBlue.main,
  },
  '&:active': {
    backgroundColor: theme.palette.solidBlue.lightActive,
    color: theme.palette.solidBlue.main,
    borderColor: theme.palette.solidBlue.main,
  },
  '&:focus': {
    backgroundColor: theme.palette.solidBlue.lightActive,
    color: theme.palette.solidBlue.main,
    borderColor: theme.palette.solidBlue.main,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.solidBlue.lightActive,
    color: theme.palette.solidBlue.main,
    border: `1px solid ${theme.palette.solidBlue.main}`,
    boxShadow: `inset 0 -3px 0 ${theme.palette.solidBlue.main}`,
  },
  '&.Mui-focusVisible': {
    backgroundColor: theme.palette.solidBlue.lightActive,
    color: theme.palette.solidBlue.main,
    borderColor: theme.palette.solidBlue.main,
  },
}));

const Tab = (props: any) => <StyledTab {...props} />;

export default Tab;
